// Reproductive-domain vocabulary for client-facing surfaces. Pure data.
// Enums come from admin-pregnancies.md / admin-medical-events.md (closed
// vocabularies); the public projection is PROVISIONAL(Q-118). Tones are
// semantic (good|warn|bad|open) — CSS maps them to color.

// pregnancy.state lifecycle: open → confirmed → lost | born.
export const PREGNANCY_STATE = {
    open:      { label: 'En seguimiento', tone: 'open' },
    confirmed: { label: 'Preñada',        tone: 'good' },
    lost:      { label: 'Vacía',          tone: 'bad' },
    born:      { label: 'Parto',          tone: 'good' },
};

// history[i].outcome (decisión 0041). The third literal is unconfirmed in the
// contract ("en curso" in prose) — the provisional adapter normalizes to
// `en_curso`; revisit when the real public api-reference lands.
export const HISTORY_OUTCOME = {
    born:     { label: 'Nació',    tone: 'good' },
    lost:     { label: 'Se perdió', tone: 'bad' },
    en_curso: { label: 'En curso', tone: 'open' },
};

// medical_events.type — closed vocabulary of 5 (admin-medical-events.md).
export const MEDICAL_EVENT_TYPE = {
    embryonic_loss: 'Pérdida embrionaria',
    abortion:       'Aborto',
    treatment:      'Tratamiento',
    observation:    'Observación',
    other:          'Otro',
};

// transfers[].status del informe por finca (public-reports.md): pregnant si la
// preñez está preñada o el último dx ∈ positive|ppl; empty si lost/negative;
// transferred = sin diagnóstico aún. `tone` = el del <Badge> común (D-005).
export const TRANSFER_STATUS = {
    pregnant:    { label: 'Preñada',      tone: 'good' },
    empty:       { label: 'Vacía',        tone: 'bad' },
    transferred: { label: 'Transferida',  tone: 'warn' },
};

// dx1/dx2.result del informe (vocabulario del diagnóstico).
export const DX_RESULT = {
    positive: 'Positivo',
    negative: 'Negativo',
    ppl:      'PPL',
};
